/** Hindi: terms other than price, the worker's own preferences, and the scope chips. */
export const terms = {
    "terms.title": "दाम के अलावा जो तय हुआ",
    "terms.proposed": "शर्तें: {terms}",
    "terms.when": "{day}, {window}",
    "terms.window.morning": "सुबह",
    "terms.window.afternoon": "दोपहर",
    "terms.window.evening": "शाम",
    "terms.materials.worker": "सामान कारीगर लाएगा",
    "terms.materials.household": "सामान घरवाले खरीदेंगे",
    "terms.coats.one": "पेंट का {count} कोट",
    "terms.coats.other": "पेंट के {count} कोट",
    "terms.hours.one": "दिन में {count} घंटा",
    "terms.hours.other": "दिन में {count} घंटे",
    "terms.you_asked": "(आपने कहा था: {value})",
    "terms.check": "आपके एजेंट ने कुछ शर्तें बदली हैं जो आपने नहीं कहीं। साइन करने से पहले देख लें।",
    "terms.card": "आप कब काम करते हैं और क्या लाते हैं",
    "terms.card_windows": "दिन का कौन सा समय आप काम लेते हैं",
    "terms.card_days": "आप किन दिनों काम करते हैं",
    "day.1": "सोम",
    "day.2": "मंगल",
    "day.3": "बुध",
    "day.4": "गुरु",
    "day.5": "शुक्र",
    "day.6": "शनि",
    "day.7": "रवि",
    "terms.card_public": "घर वाले आपके कार्ड पर आपके दिन और समय देखते हैं, ताकि वे आपसे तभी पूछें जब आप काम करते हैं। आपकी बुकिंग इसी फ़ोन पर रहती हैं।",
    "terms.card_materials": "सामान कौन खरीदेगा",
    "terms.card_either": "कोई भी",
    "terms.card_mine": "मैं लाऊँगा",
    "terms.card_theirs": "घरवाले खरीदें",
    "terms.card_hours": "दिन में ज़्यादा से ज़्यादा घंटे",
    "terms.card_any": "कोई भी",
    "terms.scope_read": "आपने जो लिखा, उसमें मुझे यह मिला। जो गलत हो उसे छूकर हटा दें।",
    "terms.scope_ok": "हाँ, सही है",
    "terms.scope_none": "इनमें से कोई नहीं",
    "terms.chip.rooms.one": "{count} कमरा",
    "terms.chip.rooms.other": "{count} कमरे",
    "terms.chip.area_sqft": "{count} वर्ग फ़ुट",
    "terms.chip.people.one": "{count} व्यक्ति",
    "terms.chip.people.other": "{count} लोग",
    "terms.chip.meals.one": "दिन में {count} बार खाना",
    "terms.chip.meals.other": "दिन में {count} बार खाना",
    "terms.chip.labour_yes": "पेंट आप खरीदेंगे",
    "terms.chip.labour_no": "पेंट पेंटर लाएगा",
    "terms.chip.flexible": "उस दिन कभी भी चलेगा",
    "terms.reading": "आपने जो लिखा, पढ़ रहा हूँ…",
};
//# sourceMappingURL=terms.js.map